import { BaseApiClient } from './base-client';

export class AccountMergeApi extends BaseApiClient {

  /** Запросить мердж с TG-аккаунтом */
  async requestMerge(params: { telegramUsername?: string; telegramId?: number }): Promise<{
    success: boolean;
    requestId: number;
    message?: string;
    error?: string;
  }> {
    const response = await this.client.post('/api/account-merge/request', params);
    return response.data;
  }

  /** Поллинг статуса запроса */
  async getRequestStatus(requestId: number): Promise<{
    success: boolean;
    status: 'pending' | 'confirmed' | 'rejected' | 'expired';
  }> {
    const response = await this.client.get(`/api/account-merge/request-status/${requestId}`);
    return response.data;
  }

  /** Получить активный pending запрос (если есть) */
  async getActiveRequest(): Promise<{
    success: boolean;
    hasActive: boolean;
    requestId?: number;
    targetUsername?: string;
    expiresAt?: string;
  }> {
    const response = await this.client.get('/api/account-merge/active');
    return response.data;
  }
}
